import React from "react";
import {Modal, Radio, Space} from "antd";
import {useTranslation} from "react-i18next";
import {ButtonContainer} from "../ComponentStyles";

const ExportExcelDataModal = ({visibility, onCancel, exportExcelData, setType}) => {
    const {t} = useTranslation(["shiftSuggestion"]);
    const onOk = async () => {
        exportExcelData();
        onCancel();
    };

    return (
        <Modal
            centered
            width={400}
            title={t("companyDetail.actions.exportWithExcel", {
                ns: "companyDetail"
            })}
            visible={visibility}
            onOk={onOk}
            okText={t("modal.sendButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
            onCancel={onCancel}
        >
            <Radio.Group onChange={e => setType(e.target.value)} defaultValue="vigo">
                <ButtonContainer>
                    <Space size={"large"}>
                        <Radio.Button value="vigo">Vigo</Radio.Button>

                        <Radio.Button value="vigoplus">Vigo+</Radio.Button>
                    </Space>
                </ButtonContainer>
            </Radio.Group>
        </Modal>
    );
};

export default ExportExcelDataModal;
